import { render, staticRenderFns } from "./BonusBox.vue?vue&type=template&id=efe9d4e0&lang=pug"
import script from "./BonusBox.vue?vue&type=script&lang=js"
export * from "./BonusBox.vue?vue&type=script&lang=js"
import style0 from "./BonusBox.vue?vue&type=style&index=0&id=efe9d4e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports